var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1969 10.0138L16.1969 10.0138L16.1992 10.0169C16.5059 10.4318 16.6385 10.9363 16.5841 11.4439L16.584 11.4439L16.5829 11.4575L16.3057 14.9403C16.2504 15.5009 16.1959 15.9435 15.953 16.2714C15.7418 16.5565 15.3011 16.8547 14.2013 16.8547H5.4113C4.31136 16.8547 3.8682 16.5563 3.65613 16.2714C3.41316 15.945 3.35813 15.5036 3.30698 14.9495L3.02974 11.4502L3.02984 11.4502L3.02882 11.4399C2.97477 10.8994 3.13555 10.3527 3.48555 9.90291C3.66135 9.68545 3.87146 9.51229 4.10335 9.38742L4.10338 9.38747L4.10983 9.38387C4.42598 9.20756 4.76973 9.11719 5.1338 9.11719H14.4713C14.8376 9.11719 15.187 9.2086 15.4916 9.38183L15.4987 9.38586L15.5059 9.38965C15.7266 9.50578 15.9194 9.66179 16.0862 9.86158L16.1969 10.0138ZM8.0063 14.3597H11.5988C12.1674 14.3597 12.6238 13.9033 12.6238 13.3347C12.6238 12.7782 12.1721 12.3097 11.5988 12.3097H8.0063C7.43303 12.3097 6.9813 12.7782 6.9813 13.3347C6.9813 13.8912 7.43302 14.3597 8.0063 14.3597Z",
    fill: "#22222A",
    stroke: "#22222A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2023 7.08758C16.2533 7.46888 15.8347 7.72815 15.4632 7.62811C15.1472 7.54302 14.8183 7.50047 14.4788 7.50047H5.13381C4.78864 7.50047 4.44787 7.54664 4.1234 7.63541C3.7567 7.73574 3.34131 7.48554 3.34131 7.10536V5.85047C3.34131 3.17297 4.15881 2.35547 6.83631 2.35547H7.72131C8.79381 2.35547 9.13131 2.70047 9.56631 3.26297L10.4663 4.46297C10.6538 4.71797 10.6613 4.73297 10.9913 4.73297H12.7763C15.0317 4.73297 15.9651 5.3142 16.2023 7.08758Z",
    fill: "#22222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.3b0e08d237e6af52c99891014be736b3.svg";
export { ForwardRef as ReactComponent };